import { buildContactName } from 'vio-libs';
import { isMarketAssignable } from '../user/lib';
export function getExistingLocations(allLocations, locations) {
    if (!locations) {
        return;
    }
    return allLocations.filter(location => locations.includes(location.slug)).map(location => {
        const { name: label, slug: value } = location;
        return {
            label,
            value
        };
    });
}
export function getContactsArray(contacts, consumerAPI) {
    if (!contacts) {
        return [];
    }
    return contacts.map(contact => {
        if (consumerAPI) {
            const { id } = contact;
            return id;
        }
        const { contact_id } = contact;
        return contact_id;
    });
}
export function getContactsOptions(contacts, consumerAPI) {
    if (!contacts) {
        return;
    }
    return contacts.map(contact => {
        const label = buildContactName(contact);
        let value;
        if (consumerAPI) {
            ({
                id: value
            } = contact);
        }
        else {
            ({
                contact_id: value
            } = contact);
        }
        return {
            label,
            value
        };
    });
}
export function getEdgeMarketsOptions(edgeMarkets) {
    if (!edgeMarkets) {
        return;
    }
    return edgeMarkets.map(edgeMarket => {
        const { name, slug } = edgeMarket;
        return {
            label: name,
            value: slug
        };
    });
}
export function getRolesOptions(roles, consumerAPI) {
    if (!roles) {
        return;
    }
    return roles.map(role => {
        const { name } = role;
        let authorizations;
        if (consumerAPI) {
            const { permissions } = role;
            authorizations = permissions;
        }
        else {
            const { authorizations: roleAuthorizations } = role;
            authorizations = roleAuthorizations;
        }
        return {
            isMarketAssignable: isMarketAssignable(authorizations),
            label: name,
            value: name
        };
    });
}
